const schoolLogoPath = "assets/educationMedia/";

const education = [
	{
		school: "University of Warwick",
		schoolLogo: schoolLogoPath + "warwick.png",
		grade: "First Class",
		title: "BSc Computer Science",
		startDate: "October 2021",
		endDate: "July 2024",
		duration: "3 years",
		desc: [],
	},
	{
		school: "Dartford Grammar School",
		schoolLogo: schoolLogoPath + "dgs.jpg",
		grade: "44/45",
		title: "International Baccalaureate",
		startDate: "August 2021",
		endDate: "September 2019",
		duration: "2 years",
		desc: [],
	},
];

export default education;
